import { checkEnvironment } from '@saviynt/common';

const getRolesListApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/roles`;
};

export default getRolesListApiUrl;
